import React from 'react';
import { Icon, Txt } from '@vst/beam';
import { OpenInNew } from '@vst/beam-icons/icons';

import { useIsActiveRoute, useScreenResolution } from '@app/hooks';

import { NavItem } from '../types';

import styles from './styles.module.scss';

export const TabItem = ({
  label,
  path,
  onClick,
  showIcon,
}: NavItem & {
  showIcon: boolean;
  onClick: React.MouseEventHandler<HTMLAnchorElement>;
}) => {
  const { isLarge, isExtraLarge } = useScreenResolution();
  const isMobile = !isLarge && !isExtraLarge;
  const isActive = useIsActiveRoute(path);

  const className = isActive ? `${styles.navItem} ${styles.selected}` : styles.navItem;

  const customStyle = showIcon ? { display: 'flex', gap: 4, alignItems: 'center' } : {};

  return (
    <div className={styles.tabContainer}>
      <a href={path} className={className} onClick={onClick} data-cy={label} id={path} style={customStyle}>
        <Txt
          component="span"
          variant={isActive && isMobile ? 'labelMedium' : 'bodySmallRegular'}
          color={isActive ? 'regular' : 'inherit'}
        >
          {label}
        </Txt>
        {showIcon && <Icon size={16} icon={OpenInNew} color={isActive ? 'gray_800' : 'inherit'} />}
      </a>
      {!isMobile && <div className={isActive ? styles.activeTab : styles.inactiveTab} />}
    </div>
  );
};
